import {createAsyncThunk} from '@reduxjs/toolkit';
import axios from 'axios';
import {getEnv} from '../../../../../../common/env/env';
import {ServerEnv} from '../../../../../../common/env/ServerEnv.enum';
import {ApiStatusCodeVo} from '../../../../../../common/shared/api/cms/vo/enums/ApiStatusCodeVo.enum';
import {PagewebError} from '../../../../../../errors/PagewebError.class';
import {PagewebErrorType} from '../../../../../../errors/PagewebErrorType.enum';
import {SerializedPagewebError} from '../../../../../../errors/SerializedPagewebError.interface';
import {thunkSerializeError} from '../../../../../../errors/thunkSerializeError.function';
import {createViewerInfo} from '../../../../../../graphql/factory/ViewerInfo';
import {ViewerInfo} from '../../../../../../graphql/generated/types';
import {VIEWER_INFO_STATE_NAME} from '../constant/viewerConstant';

export const fetchTextViewerPreviewInfo = createAsyncThunk<
  ViewerInfo | undefined,
  {previewKey: string; isProductId?: boolean},
  {serializedErrorType: SerializedPagewebError}
>(
  `${VIEWER_INFO_STATE_NAME}/fetchTextViewerPreviewInfo`,
  async ({previewKey, isProductId}) => {
    const envName = getEnv().envName;
    const url =
      isProductId && envName !== ServerEnv.Real
        ? `/product/external/textviewer-preview/productId/${previewKey}`
        : `/product/external/textviewer-preview/${previewKey}`;
    // 텍스트뷰어 웹 미리보기에서는 API에 쿠키를 사용하지 않아서 credentials 없이 보냅니다.
    // 위 API가 있는 서버들은 Access-Control-Allow-Origin 응답헤더가 '*'로 세팅되어있습니다. (@odin)
    const response = await axios.get(url, {
      baseURL: getEnv().cmsApiOrigin,
    });

    // 프리뷰 에러 발생시 처리
    if (response.data.status === ApiStatusCodeVo.ExpiredPreviewViewerToken) {
      throw new PagewebError({
        isSerializedPagewebError: true,
        type: PagewebErrorType.CmsApiStatusError,
        resultCode: response.data.status,
        message: response.data.detail,
      });
    }

    return createViewerInfo(response.data);
  },
  {
    serializeError: thunkSerializeError,
  }
);
